import React from "react";
import { css } from "emotion";
import Loading from "../../../../../../shared/Loading/Loading";
import EditCreditCardDetails from "./EditCreditCardDetails";

import { loadingStyle, defaultStyle } from "./style";
import { useNewOffer } from "../../../../../context/new-offer";

const StepEditCreditCard = props => {
	const { setCreditCardData, creditCardData } = useNewOffer();

	const setData = data => {
		setCreditCardData({
			...creditCardData,
			data: { ...creditCardData.data, ...data }
		});
	};

	return creditCardData.isFetching ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	) : (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<div className="row">
				<div className="col-xs-16">
					<EditCreditCardDetails
						checkData={props.checkData}
						setData={setData}
						creditCardData={creditCardData.data}
					/>
				</div>
			</div>
		</div>
	);
};

export default StepEditCreditCard;
